/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutFilled = createReactComponent("filled", "layout-filled", "IconLayoutFilled", [["path", { "d": "M8 3a3 3 0 0 1 3 3v1a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-1a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M8 12a3 3 0 0 1 3 3v3a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-3a3 3 0 0 1 3 -3z", "key": "svg-1" }], ["path", { "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-2" }]]);

export { IconLayoutFilled as default };
//# sourceMappingURL=IconLayoutFilled.mjs.map
